import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { COMPANY_AUTH_PRIMARY_BUTTON_STYLES } from "web-apps/company/components/shared/companyAuth.buttonStyles.contract";
import { ContinueButton, StyledForm, StyledTitle } from "./confirmation.styled";

type Props = {
  handleLogin: () => Promise<void>;
};

export const Confirmation: React.FC<Props> = ({ handleLogin }) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <StyledForm
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <StyledTitle>{t("RegisterCompany.CompanyAdded")}</StyledTitle>
      <ContinueButton
        label={t("RegisterCompany.Continue")}
        disabled={isSubmitting}
        isLoading={isSubmitting}
        onClick={async () => {
          if (isSubmitting) {
            return;
          }

          setIsSubmitting(true);
          try {
            await handleLogin();
          } finally {
            setIsSubmitting(false);
          }
        }}
        styleOverrides={COMPANY_AUTH_PRIMARY_BUTTON_STYLES}
      />
    </StyledForm>
  );
};
